import { render, staticRenderFns } from "./addEign.vue?vue&type=template&id=839c5fee"
import script from "./addEign.vue?vue&type=script&lang=js"
export * from "./addEign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports